<template>
  <div class="container start-container">
    <div class="start-block">
        <div class="start-block__title">
            <img src="../img/logo.svg" alt="">
            <p class="welcome">Добро пожаловать<br> ARTSTEP presentation</p>
        </div>
        <p
          @click="nextPage"
          class="linkBtn"
            >START
        </p>
    </div>
  </div>
</template>
<script>

export default {
  methods: {
    nextPage(){
      if(localStorage.getItem('userInfo') == null){
        this.$router.push({name: 'registration'})
      }else{
        this.$router.push({name: 'mainPage'});
      }
    }
  }
};
</script>